import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const FieldLabel = ({ children, mods={}, htmlFor, startIcon, endIcon }) => {
    const { className } = useMods(FieldLabel, { mods });

    return (
        <label
            className={ className }
            htmlFor={ htmlFor }
        >
            { startIcon }
            { children }
            { endIcon }
        </label>
    );
};

FieldLabel.displayName = 'Field__Label';

FieldLabel.propTypes = {
    children: PropTypes.node,
    endIcon: PropTypes.node,
    htmlFor: PropTypes.string,
    mods: PropTypes.object,
    startIcon: PropTypes.node
};

export default FieldLabel;
